import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PanelContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: ${(props) => props.s.overflow || ''};
  overflow-x: ${(props) => props.s.overflowX || ''};
  overflow-y: ${(props) => props.s.overflowY || 'auto'};
`;

export const Panel = ({ header, children, s }) => (
  <PanelContainer s={s}>
    <div>{header}</div>
    <div>{children}</div>
  </PanelContainer>
);

Panel.defaultProps = {
  s: {},
};

Panel.propTypes = {
  s: PropTypes.shape({
    overflow: PropTypes.string,
  }),
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};
